import React, { Component } from 'react'

// Components
import PrivacyPolicy from '../../components/PrivacyPolicy'

// Utils
import { translation } from '../../../utils/helpers'

// styles
import './footer.scss'

class Footer extends Component {
  render () {
    return (
      <div className='footer'>
        <div className='footer__info'>
          <div>{translation('2125')}</div>
          <div>{translation('38')}: +45 70 70 72 85</div>
          <div>{translation('2126')}: info@apromas.com</div>
        </div>
        <PrivacyPolicy text={translation(16653)} />
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/app/shared/components/Footer/index.js